import { Box, ButtonBase, Radio, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

interface IRadioCard {
	children: ReactNode;
	selected?: boolean;
	value: string;
	title: string;
}

const RadioCard: FC<IRadioCard> = ({ children, selected, value, title }) => {
	return (
		<ButtonBase
			component='label'
			sx={{
				cursor: 'pointer',
				flex: 1,
				borderRadius: 2,
				mb: 2,
				border: 2,
				borderColor: selected ? 'primary.main' : 'grey.300',
				display: 'flex',
				alignItems: 'flex-start',
				justifyContent: 'flex-start',
				textAlign: 'left',
				flexDirection: 'column',
				boxShadow: 'none',
			}}
		>
			<Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
				<Radio checked={selected} value={value} />
				<Typography sx={{ fontWeight: 'bold' }}>{title}</Typography>
			</Box>
			<Box sx={{ px: 4, pb: 4, width: '100%' }}>{children}</Box>
		</ButtonBase>
	);
};

export default RadioCard;
